
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg" style={{ fontFamily: '"Pacifico", serif' }}>M</span>
              </div>
              <div>
                <div className="text-lg font-bold text-white" style={{ fontFamily: '"Pacifico", serif' }}>
                  MUSLIM CERAMICA
                </div>
              </div>
            </div>
            <p className="text-gray-300 mb-4">
              Официальный представитель заводов Terramic, Wan SHENG, MinTao в Костанайской области
            </p>
            <div className="flex gap-3">
              <a 
                href="https://instagram.com/kafel_muslim_ceramica"
                target="_blank"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a 
                href="https://wa.me/77085773668"
                target="_blank"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Навигация</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Главная
                </Link>
              </li>
              <li>
                <Link to="/catalog" className="text-gray-300 hover:text-white transition-colors">
                  Каталог товаров
                </Link>
              </li>
              <li>
                <Link to="/b2b" className="text-gray-300 hover:text-white transition-colors">
                  Для профессионалов
                </Link>
              </li>
              <li>
                <a 
                  href="https://instagram.com/kafel_muslim_ceramica"
                  target="_blank"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Продукция</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Керамогранит 60×60</li>
              <li>Керамогранит 120×60</li>
              <li>Матовые поверхности</li>
              <li>Глянцевые поверхности</li>
              <li>Мраморные текстуры</li>
              <li>Однотонные коллекции</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Контакты</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-green-400 mt-1"></i>
                <div>
                  <p>г. Костанай</p>
                  <p>ул. Карбышева 8/1</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-green-400"></i>
                <div>
                  <p>+7 708 577-36-68</p>
                  <p>+7 775 963-09-96</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-time-line text-green-400"></i>
                <p>Ежедневно с 9:00 до 19:00</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 MUSLIM CERAMICA. Все права защищены.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            className="text-gray-400 hover:text-white text-sm transition-colors mt-4 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
